/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../encoder';

import {Observable} from 'rxjs';

import {EmailPersonalToken} from '../model/emailPersonalToken';
import {SaveQueryToken} from '../model/saveQueryToken';

import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';


@Injectable()
export class ConfiguratorTokenService {

    protected basePath = 'https://dmp.airiane.com/services/configurator';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Créer un token personnel pour un email donné
     * Cette requête permet de créer un token personnel pour un email donné.&lt;br&gt;La requête prend en paramètre l&#39;&lt;b&gt;email&lt;/b&gt; du client, &lt;b&gt;&#39;X_DATASTORE_ID&#39;&lt;/b&gt; qui correspond au code du datastore/tenant et &lt;b&gt;X_PARTNER_ID&lt;/b&gt; qui correspond au code d&#39;affilié.&lt;br&gt;La requête retourne un token personnel qui est un identifiant unique pour chaque email.
     * @param xDataStoreID X-DataStoreID
     * @param X_PARTNER_ID X-PARTNER-ID
     * @param email email
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
     public createEmailPersonalTokenUsingPOST(xDataStoreID: string, X_PARTNER_ID: string, email: string, observe?: 'body', reportProgress?: boolean): Observable<EmailPersonalToken>;
     public createEmailPersonalTokenUsingPOST(xDataStoreID: string, X_PARTNER_ID: string, email: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EmailPersonalToken>>;
     public createEmailPersonalTokenUsingPOST(xDataStoreID: string, X_PARTNER_ID: string, email: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EmailPersonalToken>>;
     public createEmailPersonalTokenUsingPOST(xDataStoreID: string, X_PARTNER_ID: string, email: string, observe: any = 'body', reportProgress = false ): Observable<any> {

         if (xDataStoreID === null || xDataStoreID === undefined) {
             throw new Error('Required parameter xDataStoreID was null or undefined when calling createEmailPersonalTokenUsingPOST.');
         }

         if (X_PARTNER_ID === null || X_PARTNER_ID === undefined) {
             throw new Error('Required parameter X_PARTNER_ID was null or undefined when calling createEmailPersonalTokenUsingPOST.');
         }

         if (email === null || email === undefined) {
             throw new Error('Required parameter email was null or undefined when calling createEmailPersonalTokenUsingPOST.');
         }

         let headers = this.defaultHeaders;
         if (xDataStoreID !== undefined && xDataStoreID !== null) {
             headers = headers.set('X-DataStoreID', String(xDataStoreID));
         }
         if (X_PARTNER_ID !== undefined && X_PARTNER_ID !== null) {
             headers = headers.set('X-PARTNER-ID', String(X_PARTNER_ID));
         }

         // to determine the Accept header
         const httpHeaderAccepts: string[] = [
             'application/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected != undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
             'application/json'
         ];
         const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
         if (httpContentTypeSelected != undefined) {
             headers = headers.set('Content-Type', httpContentTypeSelected);
         }

         return this.httpClient.post<EmailPersonalToken>(`${this.basePath}/api/token/personal/email`,
             email,
             {
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

    /**
     * Supprimer un token personnel pour un email donné
     * Cette requête permet de supprimer un token personnel pour un email donné.&lt;br&gt;La requête prend en paramètre un token personnel.&lt;br&gt;Le requête supprime le token personnel et renvoie le code &lt;b&gt;204&lt;/b&gt; en cas de succès.
     * @param token token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteTokenUsingDELETE1(token: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteTokenUsingDELETE1(token: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteTokenUsingDELETE1(token: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteTokenUsingDELETE1(token: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (token === null || token === undefined) {
            throw new Error('Required parameter token was null or undefined when calling deleteTokenUsingDELETE1.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/api/token/personal/email/${encodeURIComponent(String(token))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lister tous les tokens des requêtes de sauvegarde
     * Cette requête permet de lister tous les tokens des requêtes de sauvegarde.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllSaveQueryTokensUsingGET(observe?: 'body', reportProgress?: boolean): Observable<Array<SaveQueryToken>>;
    public getAllSaveQueryTokensUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SaveQueryToken>>>;
    public getAllSaveQueryTokensUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SaveQueryToken>>>;
    public getAllSaveQueryTokensUsingGET(observe: any = 'body', reportProgress = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<SaveQueryToken>>(`${this.basePath}/api/token/save-query/`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtenir ou réinitialiser le token pour d&#39;une requête de sauvegarde
     * Cette requête permet de récupérer ou de réinitialiser le token pour une requête de sauvegarde.&lt;br&gt;Si le paramètre &lt;b&gt;&#39;id&#39;&lt;/b&gt; correspond à l&#39;identifiant d&#39;une requête de sauvegarde dans la base de données, la requête retourne le token associé à cette requête si &lt;b&gt;&#39;reset&#39;&lt;/b&gt; est à &lt;b&gt;&#39;false&#39;&lt;/b&gt;.&lt;br&gt;Si le paramètre &lt;b&gt;&#39;id&#39;&lt;/b&gt; correspond à l&#39;identifiant d&#39;une requête de sauvegarde dans la base de données, et si de plus &lt;b&gt;&#39;reset&#39;&lt;/b&gt; est à &lt;b&gt;&#39;true&#39;&lt;/b&gt;, la requête réinitialise le token associé à cette requête et le renvoie.&lt;br&gt;Si le paramètre &lt;b&gt;&#39;id&#39;&lt;/b&gt; ne correspond à aucun identifiant d&#39;une requête de sauvegarde dans la base de données, la requête génère un nouveau token pour cette dernière et le renvoie.
     * @param id id
     * @param reset reset
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOrGenerateSaveQueryTokenUsingPOST(id: string, reset?: boolean, observe?: 'body', reportProgress?: boolean): Observable<SaveQueryToken>;
    public getOrGenerateSaveQueryTokenUsingPOST(id: string, reset?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SaveQueryToken>>;
    public getOrGenerateSaveQueryTokenUsingPOST(id: string, reset?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SaveQueryToken>>;
    public getOrGenerateSaveQueryTokenUsingPOST(id: string, reset?: boolean, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getOrGenerateSaveQueryTokenUsingPOST.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }
        if (reset !== undefined && reset !== null) {
            queryParameters = queryParameters.set('reset', <any>reset);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<SaveQueryToken>(`${this.basePath}/api/token/save-query`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Récupérer un token pour une requête de sauvegarde par son identifiant
     * Cette requête permet de récupérer un token pour une requête de sauvegarde par son identifiant.
     * @param uuid uuid
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSaveQueryTokenUsingGET(uuid: string, observe?: 'body', reportProgress?: boolean): Observable<SaveQueryToken>;
    public getSaveQueryTokenUsingGET(uuid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SaveQueryToken>>;
    public getSaveQueryTokenUsingGET(uuid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SaveQueryToken>>;
    public getSaveQueryTokenUsingGET(uuid: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (uuid === null || uuid === undefined) {
            throw new Error('Required parameter uuid was null or undefined when calling getSaveQueryTokenUsingGET.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SaveQueryToken>(`${this.basePath}/api/token/save-query/${encodeURIComponent(String(uuid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Récupérer un token personnel pour un email donné
     * Cette requête permet de récupérer un token personnel pour un email donné.&lt;br&gt;La requête prend en paramètre le &lt;b&gt;token&lt;/b&gt; personnel.&lt;br&gt;Si le token corresond à un email existant dans la base de données, la requête le renvoie ainsi que d&#39;autres informations à propos au datastore et de l&#39;affilié qui leur est associé.&lt;br&gt;Elle renvoie aussi un code de succès &lt;b&gt;200&lt;/b&gt; en cas de succès.&lt;br&gt;Si le token n&#39;existe pas dans la base de données, la requête renvoie un code d&#39;erreur &lt;b&gt;404&lt;/b&gt;.
     * @param token token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTokenUsingGET(token: string, observe?: 'body', reportProgress?: boolean): Observable<EmailPersonalToken>;
    public getTokenUsingGET(token: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EmailPersonalToken>>;
    public getTokenUsingGET(token: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EmailPersonalToken>>;
    public getTokenUsingGET(token: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (token === null || token === undefined) {
            throw new Error('Required parameter token was null or undefined when calling getTokenUsingGET.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<EmailPersonalToken>(`${this.basePath}/api/token/personal/email/${encodeURIComponent(String(token))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
